import styled from 'styled-components';

export const Container = styled.div`
  .summary {
    padding: 22px 30px;
  }
  & .data-row:not(.data-header) {
    position: relative;
  }
  & .data-row {
    & .data-column {
      padding: 0 29px 0 0;
      &:nth-child(6) {
        padding-right: 0;
      }
    }
    .message {
      bottom: 10px;
    }
    .pending {
      color: #896a01;
      background-color: #faf9d1;
    }
    .failure {
      color: #c82e29;
      background-color: #fbefee;
    }
  }
`;

export const DateContainer = styled.div`
  flex-wrap: wrap;
`;

export const ModalTitle = styled.div`
  font-weight: bold;
  color: #3a3a3a;
  margin-bottom: 32px;
`;

export const ButtonList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

export const DoubleIconButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  margin-bottom: 16px;
  background: none;
  border: 1px solid rgb(228, 228, 228);
  color: rgb(74, 74, 74);
  font-size: 0.875rem;
  line-height: 1;
  border-radius: 2px;
  cursor: pointer;

  .left,
  .right {
    display: flex;
    align-items: center;
  }
`;
